import { memo } from 'react';

import { InceptIcon, InceptIconProps } from '../InceptIcon';

const IconAssetBoatComponent: React.FC<InceptIconProps> = ({
  color = 'var(--chakra-colors-brand-primary-fg, currentColor)',
  brandColor = 'var(--chakra-colors-brand-primary-solid)',
  fillColor = 'var(--chakra-colors-brand-primary-contrast)',
  viewBox = '0 0 80 80',
  ...props
}: InceptIconProps) => (
  <InceptIcon viewBox={viewBox} {...props}>
    <g
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="0.75"
    >
      <path
        d="m25.493 36.374 15.567 8.971 1.9-10.525a8 8 0 0 1-2.56-.943l-8.156-4.7a1.6 1.6 0 0 1-.61-.623z"
        fill={brandColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M38.332 47.875q.477-.253.944-.522l2.141-1.236h.002l3.95-2.281.74-.428 14.997-8.658-.002-.004h.001l4.005-2.315 3.555-2.053 2.564 2.698-34.116 19.632c-1.204.696-2.51 1.2-3.87 1.494L9.491 59.336v-4.934a.696.696 0 0 0 .843.645l2.31-.499 3.208-.694 3.2-.691 3.193-.69 3.186-.69 3.18-.687 2.19-.473a30 30 0 0 0 4.206-1.244 29 29 0 0 0 3.325-1.504"
        fill={fillColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        clipRule="evenodd"
        d="M70.979 32.643a.5.5 0 0 1 .75.433c0 .832-.294 1.71-.737 2.556-.446.852-1.061 1.708-1.746 2.506-1.367 1.592-3.058 3.008-4.363 3.762L44.655 53.578a43.3 43.3 0 0 1-19.85 5.762l-15.293.668a.5.5 0 0 1-.521-.499v-.173c0-.235.164-.44.394-.49l23.752-5.133a12.9 12.9 0 0 0 3.726-1.438zM37.362 53.14a13.9 13.9 0 0 1-4.013 1.55l-18.995 4.105 10.408-.453a42.3 42.3 0 0 0 19.393-5.63l20.228-11.679c1.19-.687 2.797-2.024 4.104-3.547.651-.758 1.218-1.552 1.619-2.318q.313-.599.472-1.14z"
        fill={color}
        fillRule="evenodd"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M68.664 30.378 65.11 32.43l-4.005 2.314h-.002l-4.159-7.267a1.1 1.1 0 0 0-.521-.682l-7.427-4.281 3.023-1.747z"
        fill={fillColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M56.944 27.477a1.11 1.11 0 0 1-.521 1.248l-8.183 4.724a7.6 7.6 0 0 1-7.595.003l-8.155-4.7a1.126 1.126 0 0 1 0-1.956l10.025-5.79a3.86 3.86 0 0 1 3.858-.003l2.623 1.512 7.427 4.28c.277.16.451.41.521.682"
        fill={fillColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M41.42 46.606a.49.49 0 0 1-.245-.916l3.948-2.28a.491.491 0 0 1 .49.851l-3.948 2.28a.5.5 0 0 1-.244.066z"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M46.108 43.899a.49.49 0 0 1-.245-.916l14.95-8.631a.49.49 0 0 1 .574-.005l.005.004a.492.492 0 0 1-.04.823l-14.999 8.658a.5.5 0 0 1-.244.066"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m9.387 58.856 23.753-5.134a12.9 12.9 0 0 0 3.727-1.44l34.117-19.63"
        stroke={fillColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M42.27 20.58a4.37 4.37 0 0 1 4.347-.003l2.377 1.37 2.78-1.605a.49.49 0 0 1 .49 0l16.645 9.61.03.02.007.005a.5.5 0 0 1 .069.058l.005.004 2.563 2.7c.086.09.135.211.135.337 0 1.79-1.349 3.738-2.48 5.056-1.305 1.52-2.977 2.96-4.361 3.76L44.649 53.57a43.45 43.45 0 0 1-19.846 5.76L9.51 60h-.022l-.024-.003a.5.5 0 0 1-.131-.025q-.016-.004-.032-.01l-.024-.011a.5.5 0 0 1-.129-.09q-.02-.02-.037-.042-.013-.015-.025-.03l-.013-.023A.5.5 0 0 1 9 59.529L9 59.51l.001-4.94q.001-.036.008-.072-.005-.035-.008-.069v-.007L9 54.417v-.107c.01-.205.076-.409.19-.586l5.207-8.027a30 30 0 0 1 2.021-2.756l.001-.001a30 30 0 0 1 2.55-2.724l.39-.361a29.7 29.7 0 0 1 5.074-3.72l7.27-9.256.005-.006c.138-.206.317-.377.535-.503zm19.118 14.567-.01.008a.5.5 0 0 1-.081.042L41.663 46.543l-.005.002-2.136 1.235a29.832 29.832 0 0 1-8.615 3.324l-20.47 4.424a1.2 1.2 0 0 1-.456.01v3.46l14.78-.646a42.5 42.5 0 0 0 19.397-5.63l20.23-11.68c2.467-1.425 6.165-5.194 6.343-7.776l-2.158-2.27zM24.76 37.082a28.753 28.753 0 0 0-4.74 3.498l-.006.004a29 29 0 0 0-2.836 2.976l-.004.006c-.7.848-1.359 1.745-1.955 2.665l-5.205 8.027a.2.2 0 0 0-.034.098v.021c.004.06.037.12.085.158q.07.054.165.034l20.467-4.425a28.874 28.874 0 0 0 8.334-3.216l1.404-.81zm.733-.709 15.568 8.972L42.96 34.82a8 8 0 0 1-2.56-.943l-8.156-4.7a1.6 1.6 0 0 1-.61-.623zm31.623-7.606q-.182.227-.449.383l-8.182 4.724a8.15 8.15 0 0 1-4.55 1.067L42.09 45.164l18.347-10.6zm-7.138-6.253 6.689 3.856c.353.204.608.525.728.909l3.89 6.796 6.399-3.696-15.664-9.045zm-5.533-1.534c-.582 0-1.165.15-1.684.45l-10.026 5.79a.65.65 0 0 0-.227.22.65.65 0 0 0-.071.497c.03.116.107.279.298.39l8.156 4.7a7.1 7.1 0 0 0 2.7.898 7.15 7.15 0 0 0 4.403-.901l8.184-4.724a.62.62 0 0 0 .29-.7l-.001-.01a.6.6 0 0 0-.29-.37l-7.381-4.254a.5.5 0 0 1-.11-.063l-2.559-1.475a3.4 3.4 0 0 0-1.682-.448"
        fill={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M57.116 28.767c-.122.15-.272.281-.449.383l-8.182 4.725a8.15 8.15 0 0 1-4.55 1.066L42.09 45.165l18.347-10.6z"
        fill={brandColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M37.362 53.14a13.9 13.9 0 0 1-4.013 1.55l-18.995 4.105 10.408-.453a42.3 42.3 0 0 0 19.393-5.63l20.228-11.679c1.19-.687 2.797-2.024 4.104-3.547.651-.758 1.218-1.552 1.619-2.318q.313-.599.472-1.14zM24.76 37.083a28.746 28.746 0 0 0-4.74 3.498l-.006.004a29 29 0 0 0-2.836 2.975l-.004.006c-.7.848-1.358 1.745-1.955 2.665l-5.205 8.027a.2.2 0 0 0-.034.098v.015l.001.007c.003.06.036.12.085.158q.07.053.164.033l20.468-4.425a28.851 28.851 0 0 0 4.127-1.222l.008-.002a29 29 0 0 0 4.199-1.992l1.403-.81z"
        fill={fillColor}
        vectorEffect="non-scaling-stroke"
      />
    </g>
  </InceptIcon>
);

export const IconAssetBoat = memo(IconAssetBoatComponent);
